import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { slideInOutBlock } from '@radioking/ui/animations';
import { map } from 'rxjs/operators';

import { ChildBac } from '../../../models/bac.model';
import { LibraryBacHelperService } from '../../../services/library-bac-helper.service';
import { CloseBac, OpenBac, ToggleBac } from '../../../states/bacs.actions';
import { BacsState } from '../../../states/bacs.state';

@Component({
  selector: 'rk-library-sbac-group',
  templateUrl: './library-sbac-group.component.html',
  styleUrls: ['./library-sbac-group.component.scss'],
  animations: [slideInOutBlock],
})
export class LibrarySbacGroupComponent implements OnInit {
  @HostBinding('class.open')
  public isOpen: boolean;

  @HostBinding('class.active')
  public isActive: boolean;

  @HostBinding('class.has-child-open')
  public hasChildOpen = false;

  @Input()
  bac: ChildBac;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly store: Store,
    private readonly uiHelper: LibraryBacHelperService,
  ) {}

  ngOnInit() {
    this.isOpen = false;
    // Listen to store bac openings
    this.store
      .select(BacsState.isBacOpen)
      .pipe(map(fn => fn(this.bac.id)))
      .subscribe(val => {
        this.isOpen = val;

        if (this.isOpen && (!this.bac.children || this.bac.children.length === 0)) {
          this.store.dispatch(new CloseBac(this.bac.id));
        }
      });

    // Listen for route changes
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (!event.urlAfterRedirects) {
          return;
        }
        this.checkForClasses(event.urlAfterRedirects);
      }
    });
    this.route.url.subscribe(() => {
      this.checkForClasses(this.router.url);
    });
  }

  toggleChildren() {
    this.store.dispatch(new ToggleBac(this.bac.id));
  }

  checkForClasses(url: string): void {
    // set the active route or not
    this.isActive = this.uiHelper.isBacActive(url, this.bac);

    // Check if the url can be found in
    // one of the children of this item
    this.hasChildOpen = this.uiHelper.isUrlInChildren(this.bac, url);

    if (this.hasChildOpen) {
      this.store.dispatch(new OpenBac(this.bac.id));
      // this.isOpen = true;
    }
  }

  clickMenu(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
  }
}
